/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';
import { LuCalendarRange, LuInfo, LuUsers } from 'react-icons/lu';

import { useHistory } from 'react-router-dom';

import moment from 'moment';

import { Button } from 'primereact/button';
import { Calendar, CalendarChangeEvent } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { Tooltip } from 'primereact/tooltip';

import api from '../../../../services/api';

import { useToast } from '../../../../hooks/toast';

import {
  DateFilter,
  Field,
  FilterStyles,
  Section,
} from '../../../../components/FilterKit';

interface SearchData {
  proc_cod_cliente: number;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

const toDate = (value: string | Date | Date[] | null): Date | null => (
  value instanceof Date ? value : null
);

const SearchLawsuitSummaryExcelGrouped:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();
  const startOfMonth = moment().startOf('month').format('YYYY-MM-DD hh:mm:ss');
  const endOfMonth = moment().endOf('month').format('YYYY-MM-DD hh:mm:ss');

  sessionStorage;

  const initialValues: SearchData = {
    proc_cod_cliente: 0,
    proc_data_ajuiz_inicio: new Date(startOfMonth),
    proc_data_ajuiz_final: new Date(endOfMonth),
  };

  const [customerId, setCustomerId] = useState('0');
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [dateFilterType, setDateFilterType] = useState('data');
  const [showDate, setShowDate] = useState(true);
  const [showPeriod, setShowPeriod] = useState(false);

  const dateFilterTypeOptions = [
    { name: 'Data', value: 'data', style: 'font-size: small;' },
    { name: 'Ano', value: 'ano', style: 'font-size: small;' },
  ];

  const validationSchema = null;

  const handleClear = (handleReset: () => void) => {
    setCustomerId('0');
    setInitialRegistrationDate(null);
    setFinalRegistrationDate(null);
    setDateFilterType('data');
    setShowDate(true);
    setShowPeriod(false);
    handleReset();
  };

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      const searchFormData = {
        proc_cod_cliente: customerId,
        dateFilterType,
        proc_data_ajuiz_inicio: initialRegistrationDate,
        proc_data_ajuiz_final: finalRegistrationDate,
      };

      history.push({
        pathname: '/report/lawsuit/grouped/excel',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  return (
    <FilterStyles>
      <Formik
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          isSubmitting,
          handleSubmit,
          handleReset,
        }) => (
          <form className="card search-card" onSubmit={handleSubmit}>
            <header className="search-title">
              <h3>Relatório Total de Processos Agrupado por setor - Filtro Excel </h3>
            </header>

            <div className="search-grid">
              <div className="search-col">
                <Section icon={<LuUsers />} title="Cliente">
                  <Field id="proc_cliente" label="Cliente">
                    <Dropdown
                      id="proc_cliente"
                      name="proc_cliente"
                      options={customersOptions}
                      onChange={(e) => setCustomerId(e.target.value)}
                      value={customerId}
                      className="inputfield w-full"
                      optionLabel="name"
                      optionValue="value"
                      filter
                      resetFilterOnHide
                      filterBy="name"
                      placeholder="Selecione uma opção"
                      emptyFilterMessage="Nenhum registro encontrado"
                    />
                  </Field>
                </Section>
              </div>

              <div className="search-col">
                <Section icon={<LuCalendarRange />} title="Data de registro">
                  <div className="date-filter">
                    <div className="date-head">
                      <span className="date-label">
                        Data de registro
                        <LuInfo className="date-info info-grouped" />
                        <Tooltip target=".info-grouped" position="bottom">
                          <strong>Selecione data específica ou ano</strong>
                          <br />
                          <strong>Data:</strong>
                          {' '}
                          <em>intervalo entre datas exatas.</em>
                          <br />
                          <strong>Ano:</strong>
                          {' '}
                          <em>
                            para pesquisar até o final de um ano, preencha apenas o ano final.
                          </em>
                        </Tooltip>
                      </span>
                      <SelectButton
                        id="date_filter_type"
                        className="date-mode"
                        value={dateFilterType}
                        options={dateFilterTypeOptions}
                        optionLabel="name"
                        onChange={(e) => {
                          setDateFilterType(e.value);
                          if (e.value === 'data') {
                            setShowDate(true);
                            setShowPeriod(false);
                            setInitialRegistrationDate(null);
                            setFinalRegistrationDate(null);
                          } else {
                            setShowDate(false);
                            setShowPeriod(true);
                            setInitialRegistrationDate(null);
                            setFinalRegistrationDate(null);
                          }
                        }}
                      />
                    </div>

                    {showDate ? (
                      <DateFilter
                        bare
                        withMode={false}
                        id="data_registro"
                        label="Data de registro"
                        value={{
                          mode: 'data',
                          start: toDate(initialRegistrationDate),
                          end: toDate(finalRegistrationDate),
                        }}
                        onChange={(next) => {
                          setInitialRegistrationDate(next.start);
                          setFinalRegistrationDate(next.end);
                        }}
                      />
                    ) : null}

                    {showPeriod ? (
                      <div className="date-inputs">
                        <Calendar
                          inputId="proc_data_ajuiz_inicio_mes_ano"
                          name="proc_data_ajuiz_inicio_mes_ano"
                          className="inputfield w-full"
                          value={toDate(initialRegistrationDate)}
                          onChange={(e : CalendarChangeEvent) => {
                            if (e.value !== undefined && e.value !== null) {
                              setInitialRegistrationDate(e.value);
                            }
                          }}
                          keepInvalid
                          showIcon
                          showButtonBar
                          showOnFocus={false}
                          mask="9999"
                          dateFormat="yy"
                          yearRange="1980:2030"
                          placeholder="Ano inicial"
                          view="month"
                          yearNavigator
                        />
                        <span className="date-to">até</span>
                        <Calendar
                          inputId="proc_data_ajuiz_final_mes_ano"
                          name="proc_data_ajuiz_final"
                          className="inputfield w-full"
                          value={toDate(finalRegistrationDate)}
                          onChange={(e : CalendarChangeEvent) => {
                            if (e.value !== undefined && e.value !== null) {
                              setFinalRegistrationDate(e.value);
                            }
                          }}
                          keepInvalid
                          showIcon
                          showButtonBar
                          showOnFocus={false}
                          mask="9999"
                          dateFormat="yy"
                          yearRange="1980:2030"
                          placeholder="Ano final"
                          view="month"
                          yearNavigator
                        />
                      </div>
                    ) : null}
                  </div>
                </Section>
              </div>
            </div>

            <footer className="search-actions">
              <div className="buttons">
                <Button
                  icon="pi pi-undo"
                  iconPos="left"
                  label="Limpar campos"
                  className="p-button-outlined p-button-secondary"
                  type="button"
                  onClick={() => handleClear(handleReset)}
                />
                <Button
                  icon="pi pi-check"
                  iconPos="left"
                  label="Pesquisar processos"
                  type="submit"
                  disabled={isSubmitting}
                />
              </div>
            </footer>
          </form>
        )}
      </Formik>
    </FilterStyles>
  );
};

export default SearchLawsuitSummaryExcelGrouped;
